import { openInBlobInBlank } from "../../../../../common/utils/view_utils";
import { IGetFornecedorDocumentoFileContentUseCase } from "../../../presentation/useCases/read/get_fornecedor_documento_file_content_use_case";
import { IComprasRepository } from "../../repositories/compras_repositories";

/**
 * GetFornecedorDocumentoFileContentUseCase
 */

export class GetFornecedorDocumentoFileContentUseCase implements IGetFornecedorDocumentoFileContentUseCase {
  constructor(private readonly repository: IComprasRepository) { }

  async getFornecedorDocumentoFileContent(
    idFornecedor: number,
    idFornecedorArquivo: number,
    nomeArquivo: string,
  ): Promise<void> {
    const response = await this.repository.getFornecedorDocumentoFileContent(
      idFornecedor,
      idFornecedorArquivo,
    );

    await openInBlobInBlank(nomeArquivo, response);
  }
}
